import Api from "../api/api";
import { captureVisit } from "./analytics";

const measurementId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || "G-24W88V2MW8";
let initialized = false;
let previousNavigation = null;
let previousPage = "";
const publicPage = path => /^\/(?:$|books(?:\/|$)|blog(?:\/|$)|about\/?$|contact\/?$|terms\/?$|privacy\/?$|shop(?:\/|$)|avwakindevelopment\/?$)/i.test(path);

export function trackGooglePageView(navigationKey) {
  try {
    const enabled = /^G-[A-Z0-9]+$/.test(measurementId) && process.env.NODE_ENV === "production" &&
      ["kennethlpowell.com", "www.kennethlpowell.com"].includes(window.location.hostname) &&
      publicPage(window.location.pathname) && !Api.token && Boolean(captureVisit());
    window[`ga-disable-${measurementId}`] = !enabled;
    if (!enabled || previousNavigation === navigationKey) return;
    // Campaign labels are allowlisted; private query parameters and fragments never leave the site.
    const page = new URL(window.location.pathname, window.location.origin);
    const incoming = new URLSearchParams(window.location.search);
    for (const key of ["utm_source", "utm_medium", "utm_campaign"]) {
      const value = incoming.get(key);
      if (value && /^[a-z0-9_.-]{1,100}$/i.test(value)) page.searchParams.set(key, value);
    }
    let referrer = previousPage;
    if (!referrer) { try { referrer = new URL(document.referrer).origin; } catch { referrer = ""; } }
    const fields = { page_location: page.href, page_referrer: referrer, page_title: "Kenneth L Powell" };
    if (!initialized) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", measurementId, { ...fields, send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
      if (!document.getElementById("author-google-analytics")) {
        const script = document.createElement("script");
        script.id = "author-google-analytics"; script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(script);
      }
      initialized = true;
    }
    window.gtag("set", fields);
    window.gtag("event", "page_view", { send_to: measurementId, ...fields });
    previousPage = new URL(window.location.pathname, window.location.origin).href;
    previousNavigation = navigationKey;
  } catch { /* Google telemetry must not interrupt navigation. */ }
}
